import { DefaultRoutesProps, RouteModel, RouteNames } from '@om-fe/core/core/routing/utils';

import { operatorBettingRulesComponents } from '../pages/theme1/i18n-based-pages/betting-rules/betting-rules-by-lang';
import getPageByLang from '@om-fe/core/pages/theme1/i18n-based-pages/get-page-by-lang';

import getNDWCustomRoutes from '@om-fe/ndw-core/src/routes/routes';

function getOperatorCustomRoutes({ lang }: DefaultRoutesProps): Array<Partial<RouteModel>> {
    const operatorCustomRoutes: RouteModel[] = getNDWCustomRoutes({ lang }).map((route: RouteModel) => {
        switch (route.name) {
            case RouteNames.bettingRules:
                return {
                    ...route,
                    component: getPageByLang(operatorBettingRulesComponents, lang),
                }
            default:
                return route;
        }
    });

    return operatorCustomRoutes
}

export default getOperatorCustomRoutes;